// Utility for generating consistent artist avatar colors from the palette

// Get initials from artist name (first letter of first and last name)
export function getArtistInitials(name: string): string {
  const parts = name.split(' ').filter(Boolean)
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
}

// Get a consistent color index based on artist name (deterministic)
export function getArtistColorIndex(name: string): number {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash // Convert to 32bit integer
  }
  return Math.abs(hash) % 5 // 5 color options
}

// CSS variable names for avatar background colors
export const avatarColors = [
  '--accent-primary',
  '--accent-secondary',
  '--accent-warm',
  '--accent-deep',
  '--hero-top-1',
] as const

// Get the CSS variable for an artist's avatar color
export function getArtistColorVar(name: string): string {
  const index = getArtistColorIndex(name)
  return avatarColors[index]
}
